import { h } from 'vue';
import { RouterLink } from 'vue-router';
import type { BuiTblColumn } from '@/components/bui/organisms/Tbl/types';
import TblRowActions from '@/components/bui/molecules/TblRowActions/TblRowActions.vue';
import UsedBy from '@/components/ListingPages/ItemsLister/ItemsList/FieldsRenderers/UsedBy.vue';

const organizationsColumns: BuiTblColumn[] = [
  {
    key: 'name',
    kind: 'name',
    label: 'Name',
    grow: true,
    minWidth: 180,
    selectable: true,
    sortable: true,
    sortKey: 'name',
    render: ({ item }) =>
      h('div', { class: 'bui-cell-name' }, [
        h(
          RouterLink,
          { to: `/organizations/edit/${item.id}`, class: 'title-link', onClick: (e: MouseEvent) => e.stopPropagation() },
          () => item.name,
        ),
        h('div', { class: 'bui-cell-sub' }, item.assetType ? `${item.assetType[0].toUpperCase()}${item.assetType.substring(1)}` : ''),
      ]),
  },
  {
    key: 'businessUnit',
    kind: 'text',
    label: 'Business Unit',
    grow: true,
    minWidth: 120,
    render: ({ item }) => item.businessUnitNumber || '',
  },
  {
    key: 'parent',
    kind: 'text',
    label: 'Parent',
    grow: true,
    minWidth: 140,
    render: ({ item }) => item.parentName || '',
  },
  {
    key: 'usedBy',
    kind: 'usedBy',
    label: 'Used by',
    width: 80,
    render: ({ item }) => h(UsedBy, { items: item.locations, label: 'Locations' }),
  },
  {
    key: 'actions',
    kind: 'actions',
    label: 'Actions',
    width: 100,
    render: ({ item }) => h(TblRowActions, { item }),
  },
];

export default organizationsColumns;
